<template>
  <q-bar class="bg-white">
    <div class="col text-center">{{ $t('forgetPassword.title') }}</div>
  </q-bar>
  <q-form ref="form" class="q-ma-md q-gutter-md">
    <q-input
      v-model="form.newPassword"
      class="full-width"
      outlined
      :type="isPwd ? 'password' : 'text'"
      bg-color="white"
      :label="`${$t('account.changePassword.newPassword')} *`"
      :rules="passwordRules"
    />
    <q-input
      v-model="form.confirmNewPassword"
      class="full-width"
      outlined
      :type="isPwd ? 'password' : 'text'"
      bg-color="white"
      :label="`${$t('account.changePassword.confirmNewPassword')} *`"
      :rules="confirmNewPasswordRules"
    />
    <q-btn
      class="full-width"
      outline
      :label="$t('generic.text.submit')"
      @click="onSubmit"
    />

    <div class="divider--dark full-width q-my-xl">
      {{ $t('generic.text.or') }}
    </div>

    <q-btn
      flat
      color="primary"
      class="full-width q-my-none"
      :label="$t('generic.text.backToLogin')"
      :to="{ name: 'Login' }"
    />
  </q-form>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
  data() {
    return {
      isPwd: true,
      form: {
        newPassword: '',
        confirmNewPassword: '',
      },
      passwordRules: [
        (v) =>
          !!v ||
          this.$t('generic.error.required', {
            msg: this.$t('personalInfo.password'),
          }),
      ],
      confirmNewPasswordRules: [
        (v) =>
          !!v ||
          this.$t('generic.error.required', {
            msg: this.$t('personalInfo.password'),
          }),
        (v) =>
          this.form.newPassword === v ||
          this.$t('generic.error.passwordNotMatch'),
      ],
    };
  },
  computed: {
    ...mapState({
      personalInfo: (state) => state.user.personalInfo,
    }),
  },
  methods: {
    ...mapActions({
      resetPassword: 'user/resetPassword',
    }),

    onSubmit() {
      this.$refs.form.validate().then((success) => {
        if (!success) return;
        this.resetPassword({
          userid: this.personalInfo.userid,
          userpwd: this.form.newPassword,
        })
          .then(() => {
            this.$notify.create({
              type: 'positive',
              position: 'top',
              message: this.$t('account.changePassword.success'),
            });
            this.$router.push({ name: 'Login' });
          })
          .catch(() => {
            this.$notify.create({
              type: 'negative',
              position: 'top',
              message: this.$t('account.changePassword.failed'),
            });
          });
      });
    },
  },
};
</script>
